var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t(
                            "CargoMsg.ChargeMappingFuzzySearch"
                          )
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", size: "mini", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "flex-grow": "1" }
        },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "101375",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              "config-module": "101375",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    id: "editForm",
                    "label-width": "110px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: {
                        label: _vm.$t("CargoMsg.AllowSaleProduct"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_AllowSaleProduct,
                          filterable: "",
                          no: "allowSaleProduct",
                          clearable: "",
                          "default-value":
                            _vm.editDialog.form.saleProductCode || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.saleProductCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: {
                        label: _vm.$t("CargoMsg.FullOrInside"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_FullOrInside$FULL_OR_INSIDE,
                          no: "fullOrInside",
                          clearable: "",
                          "default-value":
                            _vm.editDialog.form.fullOrInside || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.fullOrInside = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxRate"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", no: "taxRate" },
                        on: { input: _vm.handleInput, blur: _vm.handleBlur },
                        model: {
                          value: _vm.editDialog.form.taxRate,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "taxRate", $$v)
                          },
                          expression: "editDialog.form.taxRate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ChargeName"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_ChargeItem,
                          no: "chargeItemId",
                          filterable: "",
                          clearable: "",
                          "default-value": _vm.editDialog.form.chargeItemId
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.chargeItemId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: {
                        label: _vm.$t("CargoMsg.TransmitChargeName"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_ChargeGroup,
                          no: "transmitChargeName",
                          filterable: "",
                          clearable: "",
                          "tag-value": "code",
                          "default-value":
                            _vm.editDialog.form.transmitChargeCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.transmitChargeCode = p.code
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: { label: _vm.$t("CargoMsg.TransmitChargeCode") }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "transmitChargeCode" },
                        model: {
                          value: _vm.editDialog.form.transmitChargeCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "transmitChargeCode",
                              $$v
                            )
                          },
                          expression: "editDialog.form.transmitChargeCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "controlWidth",
                      attrs: { label: _vm.$t("CargoMsg.MaintainerRemarks") }
                    },
                    [
                      _c("el-input", {
                        attrs: { rows: 4, type: "textarea", no: "remark" },
                        model: {
                          value: _vm.editDialog.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remark", $$v)
                          },
                          expression: "editDialog.form.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }